'use strict';

var _classCallCheck = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var sortLinks = require('./sortLinks');

var DAGLink = require('../dag-link/dagLink');

var _require = require('../dag-link/util'),
    createDagLinkFromB58EncodedHash = _require.createDagLinkFromB58EncodedHash;

var _require2 = require('../serialize'),
    serializeDAGNode = _require2.serializeDAGNode;

var _toDAGLink = require('./toDagLink');

var _addLink = require('./addLink');

var _rmLink = require('./rmLink');

var uint8ArrayFromString = require('uint8arrays/from-string');

var uint8ArrayToString = require('uint8arrays/to-string');
/**
 * @typedef {import('cids')} CID
 * @typedef {import('../types').DAGLinkLike} DAGLinkLike
 */


var DAGNode = /*#__PURE__*/function () {
  /**
   *@param {Uint8Array | string} [data]
   * @param {(DAGLink | DAGLinkLike)[]} links
   * @param {number | null} [serializedSize]
   */
  function DAGNode(data) {
    var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var serializedSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, DAGNode);

    if (!data) {
      data = new Uint8Array(0);
    }

    if (typeof data === 'string') {
      data = uint8ArrayFromString(data);
    }

    if (!(data instanceof Uint8Array)) {
      throw new Error('Passed \'data\' is not a Uint8Array or a String!');
    }

    if (serializedSize !== null && typeof serializedSize !== 'number') {
      throw new Error('Passed \'serializedSize\' must be a number!');
    }

    var sortedLinks = links.map(function (link) {
      return link instanceof DAGLink ? link : createDagLinkFromB58EncodedHash(link);
    });
    sortLinks(sortedLinks);
    this.Data = data;
    this.Links = sortedLinks;
    Object.defineProperties(this, {
      _serializedSize: {
        value: serializedSize,
        writable: true,
        enumerable: false
      },
      _size: {
        value: null,
        writable: true,
        enumerable: false
      }
    });
  }

  _createClass(DAGNode, [{
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          data: this.Data,
          links: this.Links.map(function (l) {
            return l.toJSON();
          }),
          size: this.size
        });
      }

      return Object.assign({}, this._json);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "DAGNode <data: \"".concat(uint8ArrayToString(this.Data, 'base64urlpad'), "\", links: ").concat(this.Links.length, ", size: ").concat(this.size, ">");
    }
  }, {
    key: "_invalidateCached",
    value: function _invalidateCached() {
      this._serializedSize = null;
      this._size = null;
    }
    /**
     * @param {DAGLink | import('../types').DAGLinkLike} link
     */

  }, {
    key: "addLink",
    value: function addLink(link) {
      this._invalidateCached();

      return _addLink(this, link);
    }
    /**
     * @param {DAGLink | string | CID} link
     */

  }, {
    key: "rmLink",
    value: function rmLink(link) {
      this._invalidateCached();

      return _rmLink(this, link);
    }
    /**
     * @param {import('./toDagLink').ToDagLinkOptions} [options]
     */

  }, {
    key: "toDAGLink",
    value: function toDAGLink(options) {
      return _toDAGLink(this, options);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var buf = serializeDAGNode(this);
      this._serializedSize = buf.length;
      return buf;
    }
  }, {
    key: "size",
    get: function get() {
      if (this._size == null) {
        var serializedSize;

        if (serializedSize == null) {
          this._serializedSize = this.serialize().length;
          serializedSize = this._serializedSize;
        }

        this._size = this.Links.reduce(function (sum, l) {
          return sum + l.Tsize;
        }, serializedSize);
      }

      return this._size;
    },
    set: function set(size) {
      throw new Error("Can't set property: 'size' is immutable");
    }
  }]);

  return DAGNode;
}();

module.exports = DAGNode;